<template>
  <v-card outlined class="card-control-event">
    <v-card-title class="card-title-control-event">
      <v-tabs
        v-model="tab"
        class="tab-card-control"
        fixed-tabs
        centered
        hide-slider
        :height="40"
      >
        <v-tab v-for="item in tabCardControl" :key="item">{{ item }}</v-tab>
      </v-tabs>
    </v-card-title>
    <v-card-text class="card-content-control-event">
      <v-tabs-items v-model="tab">
        <v-tab-item v-for="item in tabCardControl" :key="item">
          <div class="div-card-dashboard-event" v-if="item === 'Events'">
            <ScreeningCatalogueAnalysisEventsTable
              :events="events"
              :idMission="currentMission.id"
              v-on:event-visualizer-method="updateVisualizerEvent"
              style="width: 100%"
            />
          </div>
          <div
            class="div-card-dashboard-event"
            v-if="item === 'Event Details' && displayedScreeningEvent != null"
          >
            <ScreeningCatalogueAnalysisEventsCard
              :eventInfo="displayedScreeningEvent"
              :idMission="currentMission.id"
            />
          </div>
          <div
            class="div-card-dashboard-event"
            v-if="item === 'Satellite report'"
          >
            <ScreeningSingleSatelliteReport :events="events" />
          </div>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </v-card>
</template>
<script>
import ScreeningCatalogueAnalysisEventsTable from './ScreeningCatalogueAnalysisEventsTable'
import ScreeningSingleSatelliteReport from './ScreeningSingleSatelliteReport'
import ScreeningCatalogueAnalysisEventsCard from './ScreeningCatalogueAnalysisEventsCard.vue'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'ScreeningCatalogueAnalysisResultCard',

  mixins: [],
  components: {
    ScreeningCatalogueAnalysisEventsTable,
    ScreeningSingleSatelliteReport,
    ScreeningCatalogueAnalysisEventsCard
  },
  data() {
    return {
      data: null,
      dialog: false,
      type: 'ScreeningCatalogueAnalysisResult',
      tabCardControl: ['Events', 'Event Details', 'Satellite report']
    }
  },
  props: {
    events: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    displayedScreeningEvent(newValue) {
      if (newValue != null) {
        this.$el.scrollIntoView({ behavior: 'smooth' })
      }
    }
  },
  beforeMount() {
    this.tab = 0
    this.setDisplayedScreeningEvent(null)
  },
  computed: {
    ...mapGetters({
      currentMission: 'currentMission',
      currentResultsLog: 'currentResultsLog',
      displayedScreeningEvent: 'displayedScreeningEvent',
      displayedScreeningTab: 'displayedScreeningTab'
    }),
    tab: {
      get() {
        return this.displayedScreeningTab
      },
      set(newValue) {
        this.setDisplayedScreeningTab(newValue)
      }
    },
    alertIdsToAlerts() {
      const groups = this?.currentResultsLog?.results?.groups
      const map = new Map()
      for (const group of groups) {
        for (const alert of group.alerts) {
          const pair = { group, alert }
          map.set(alert.id, pair)
        }
      }
      return map
    }
  },
  methods: {
    ...mapActions(['setDisplayedScreeningEvent', 'setDisplayedScreeningTab']),
    updateVisualizerEvent(eventInfo) {
      this.setDisplayedScreeningEvent(eventInfo)
      this.tab = 1
    }
  }
}
</script>
<style scoped>
.card-control-event {
  width: 100%;
  border: 2px solid;
  border-color: black;
  min-height: 600px;
}
.card-title-control-event {
  justify-content: center;
  align-content: center;
  font-size: small;
  border-bottom: 2px solid;
  border-color: black;
  height: 46px;
}
.div-card-dashboard-event {
  padding: 0%;
  width: 100%;
}
</style>
